module.exports = __webpack_public_path__ + "static/img/xmzz3.5b3737e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xmzz3.jpg
// module id = Uy+n
// module chunks = 73